// NGRP shared frontend config
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NGRP Official Party Emblem/Logo — clean circular mark used across the site
// (navbar, hero, footer, small icons). The site now serves multiple optimised
// WebP sizes from /app/frontend/public/ (with PNG-8 fallbacks alongside).
//
//   96 px  →  ~4.4 KB  (navbar, footer)
//  256 px  →  ~21 KB   (About hero, small heroes)
//  512 px  →  ~57 KB   (Home hero HD)
//
// Consumers should pick the size closest to their rendered pixel size to keep
// bytes over the wire minimal.
export const NGRP_LOGO_URL_XS = '/ngrp-logo-mark-96.webp';   // ≤64 px slots (navbar/footer)
export const NGRP_LOGO_URL    = '/ngrp-logo-mark-256.webp';  // 96–192 px slots (About emblem preview, mid marks)
export const NGRP_LOGO_URL_HD = '/ngrp-logo-mark-512.webp';  // 200–320 px slots (Home hero)

// Full-resolution NGRP Emblem "Meaning & Vision" panel graphic (used on the
// Emblem page hero). Now served locally as a compressed WebP (~246 KB) — down
// from the 1.8 MB PNG. `NGRP_EMBLEM_PANEL_URL_JPG` provides a JPEG fallback.
export const NGRP_EMBLEM_PANEL_URL = '/ngrp-emblem-panel.webp';
export const NGRP_EMBLEM_PANEL_URL_JPG = '/ngrp-emblem-panel.jpg';

// Marathi values banner used on the About page.
export const NGRP_MARATHI_BANNER_URL = 'https://customer-assets-jt897jd0.emergentagent.net/job_89f81a0c-eafc-4def-ba90-86c4c2f87252/artifacts/fx3laqpk_WhatsApp%20Image%202026-07-28%20at%2010.40.31%20AM.jpeg';

// Founder photo (Ajay Pachpute) served locally in three sizes.
//   founder-portrait.webp (450×600)  – hero portrait card
//   founder-square.webp   (400×400)  – About-page preview card
//   founder-avatar.webp   (240×240)  – tiny avatar / footer / bylines
// JPEG fallbacks exist alongside each WebP.
export const FOUNDER_PORTRAIT_URL = '/founder-portrait.webp';
export const FOUNDER_SQUARE_URL   = '/founder-square.webp';
export const FOUNDER_AVATAR_URL   = '/founder-avatar.webp';
